import Navbar from './components/Navbar';
import Footer from './components/Footer';
import About from './components/About';
import Project from './components/Project';
import Home from './components/Home';
import Skill from './components/Skill';
import { Fade } from 'react-awesome-reveal';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {

  return (
      // <div className='bg-gray-800 text-white'>
      <div>
        <Fade bottom duration={2000}>
        <Navbar />
        <Home />
        <About />
        <Project />
        <Skill />
        <Footer />
        <ToastContainer />
        </Fade>
      </div>
  );
}

export default App;
